var version = {
    "name":      "dativery",
    "buildDateCode": "20260316-093857",
    "buildDate": "Mon Mar 16 2026 09:38:57 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260316-093857",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;